import React from "react";


const ApplicationBtnCenter: React.FC = () => {

  return (
    <svg
      id="レイヤー_1"
      data-name="レイヤー 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 92.252 92.252"
    >
      <g id="グループ_679" data-name="グループ 679">
        <g id="グループ_358" data-name="グループ 358">
          <g id="グループ_493" data-name="グループ 493">
            <g id="グループ_359" data-name="グループ 359">
              <g id="グループ_360" data-name="グループ 360">
                <circle
                  id="楕円形_6"
                  data-name="楕円形 6"
                  cx="46.126"
                  cy="46.126"
                  r="46.126"
                />
                <g id="グループ_353" data-name="グループ 353">
                  <g id="グループ_354" data-name="グループ 354">
                    <g id="グループ_353-2" data-name="グループ 353-2">
                      <path
                        id="パス_1979"
                        data-name="パス 1979"
                        d="M79.32005,75.072v.008l-23.314,13.455V77.981l-4.645,2.683-1.165-2.012,5.81006-3.353,2.683-1.551,9.45606-5.457,1.157,2.012-10.613,6.128v7.872l17.949-10.362V45.546l-1.165-2.012,1.165-.671,2.683-1.551Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                      <path
                        id="パス_1980"
                        data-name="パス 1980"
                        d="M75.47313,43.534l1.165,2.012-4.644,2.683-1.165-2.012Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                      <path
                        id="パス_1981"
                        data-name="パス 1981"
                        d="M71.993,48.228l-1.165.679V69.421l-1.526.88-1.157-2.012V50.458L56.006,57.467V54.778L68.145,47.77V39.898L66.98,37.886l1.165-.671,2.683-1.551V46.219Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                      <path
                        id="パス_1982"
                        data-name="パス 1982"
                        d="M66.98009,37.883l1.165,2.012-4.644,2.683-1.165-2.012Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                      <path
                        id="パス_1983"
                        data-name="パス 1983"
                        d="M62.33507,40.566l1.165,2.012-1.165.671-2.691,1.551-9.448,5.458v17.84l12.139-7.008V63.766L50.196,70.775v7.872l1.165,2.012-1.165.671-2.691,1.551V72.33L46.34,70.318l1.165-.679V49.125l12.139-7.008V34.245l-1.157-2.012,3.848-2.222Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                      <path
                        id="パス_1984"
                        data-name="パス 1984"
                        d="M58.488,32.232l1.157,2.012L41.696,44.606v28.395l1.165,2.012-1.165.671-2.683,1.551v-33.76Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                      <path
                        id="パス_1985"
                        data-name="パス 1985"
                        d="M46.34007,70.318l1.165,2.012-4.644,2.683-1.165-2.012Z"
                        transform="translate(-13.80505 -13.205)"
                        fill="#454545"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <path
                id="パス_7666"
                data-name="パス 7666"
                d="M57.78705,68.266v-.075l-1.35-10.425a.348.348,0,0,0-.34494-.351q-.015-.00014-.03006.001h-1.225c-.2,0-.325.1-.325.3l1.4,10.475a.351.351,0,0,0,.37274.32782l.02726-.00282h1.175C57.68705,68.516,57.78705,68.441,57.78705,68.266Zm-5.625-5.275c0-.025-.025-.05-.025-.1l-1.475-9.375a.321.321,0,0,0-.35-.325h-1.225c-.2,0-.3.1-.3.275l1.45,9.475c.05.2.175.275.4.275h1.225C52.03705,63.216,52.16205,63.166,52.16205,62.991Zm5.6-11.375v-1.35a.316.316,0,0,0-.35-.35h-9.275V48.741c0-.25-.125-.375-.35-.375h-1.525a.306.306,0,0,0-.35.35v1.2h-8.625c-.4,0-.55.2-.55.575v9.225l-1.35,10.775c0,.2.125.275.35.275h1.2c.25,0,.35-.1.375-.325l1.375-10.725v-7.75h18.725a.316.316,0,0,0,.35-.35Zm-3.225,18.45v-1.45a.316.316,0,0,0-.35-.35h-7.3V56.116c0-.275-.125-.375-.35-.375h-1.3c-.25,0-.375.1-.375.375v13.75a.5.5,0,0,0,.575.575h8.725a.342.342,0,0,0,.375-.375Zm-12.1-12.275v-.075c0-.175-.1-.275-.3-.275h-1.125a.356.356,0,0,0-.4.35l-1.075,12.3c-.025.175.1.25.325.25h1.125a.329.329,0,0,0,.375-.325Zm40.7,8.45v-1.4a.374.374,0,0,0-.25-.375l-5.575-2.175h5.2a.316.316,0,0,0,.35-.35v-.975a.316.316,0,0,0-.35-.35h-9.775V59.491h8.275a.523.523,0,0,0,.6-.575V53.141a.523.523,0,0,0-.575-.6h-3.15v-1.25h4.625c.225,0,.35-.125.35-.375v-.95a.316.316,0,0,0-.35-.35h-4.625v-.875c0-.25-.1-.375-.35-.375h-1.45c-.225,0-.35.125-.35.375v.875h-8.125v-.875c0-.25-.125-.375-.35-.375h-1.45c-.25,0-.35.125-.35.375v.875h-4.625a.316.316,0,0,0-.35.35v.95c0,.25.125.375.35.375h4.625v1.25h-3.125c-.425,0-.6.2-.6.575v5.8c0,.375.175.575.6.575h8.3v1.125h-9.8a.316.316,0,0,0-.35.35v.975a.306.306,0,0,0,.35.35h5.425l-5.7,2.225a.354.354,0,0,0-.225.375v1.375c0,.15.05.25.15.25a.3548.3548,0,0,0,.15-.05l2.1-.9v.7a.306.306,0,0,0,.35.35h2.65l-3,3.85a.332.332,0,0,0-.075.175c0,.075.075.1.25.1h1.825a.487.487,0,0,0,.45-.2l2.975-3.925h10.575v2.55h-6.025c-.275,0-.375.125-.375.35v.85c0,.25.125.35.375.35h7.55a.5.5,0,0,0,.575-.575V65.616l1.975.85a.63592.63592,0,0,0,.175.05C83.08705,66.516,83.13705,66.416,83.13705,66.241Zm-7.4-13.7h-8.125V51.216h8.125Zm3.8,2.825h-15.725V53.841H79.537Zm0,2.825h-15.725v-1.55H79.537Zm-.1,6.775h-9.65l.875-1.2a.332.332,0,0,0,.075-.175c0-.075-.05-.125-.2-.125h-1.725a.523.523,0,0,0-.425.225l-.975,1.275h-3.35l6.1-2.675h3.225Z"
                transform="translate(-13.80505 -13.205)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ApplicationBtnCenter;
